import { render, staticRenderFns } from "./AppTableDefaultRow.vue?vue&type=template&id=273c382b&scoped=true&"
import script from "./AppTableDefaultRow.vue?vue&type=script&lang=ts&"
export * from "./AppTableDefaultRow.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableDefaultRow.vue?vue&type=style&index=0&id=273c382b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c382b",
  null
  
)

export default component.exports